import script from "./SelectRelateTeacherMineCoursewareModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectRelateTeacherMineCoursewareModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectRelateTeacherMineCoursewareModal.vue?vue&type=style&index=0&id=7174a8b0&scoped=true&lang=less"
script.__scopeId = "data-v-7174a8b0"

export default script